export const CORRECTION = 'correction';
export const CANCELLED = 'cancelled';
export const BONUS = 'bonus';
export const COMPLAINT = 'complaint';
